var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditRecognitionItem.jinja');
require('./MemberProfileEditRecognitionItem.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditRecognitionItem-inputIcons-delete': 'deleteRecognition'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    deleteRecognition: function (e) {
        this.remove();

        window.app.vent.trigger('MemberProfileEditRecognitionItem-remove');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditRecognitionItem.js
// module id = 222
// module chunks = 0